import styled from 'styled-components';
import { ampli } from '../../../../ampli';
import { GoToListPageButtonProps } from '../../../../components/common/buttons/GoToListPageButton';
import { IOpenMarketProduct } from '../../../../interfaces/OpenMarketProduct.interfaces';
import { chunkArrayForQuadSwiper } from '../../../../utils/chunkArrayForQuadSwiper.util';
import { getOpenMarketProductTitle } from '../../../../utils/getter/getOpenMarketProductTitle.util';
import {
  OpenMarketProductPreviewCard,
  OpenMarketProductPreviewCardPageType,
} from '../../listView/OpenMarketProductPreviewCard/OpenMarketProductPreviewCard';
import { DetailQuadSwiper } from './DetailQuadSwiper';

export const OpenMarketQuadSwiperGroup = ({
  openMarketProducts,
  goToButton,
  title,
  pageType,
  isInquiryButtonVisible = false,
  slideHeight,
}: {
  openMarketProducts: IOpenMarketProduct[];
  goToButton: GoToListPageButtonProps;
  title?: string;
  pageType: OpenMarketProductPreviewCardPageType;
  isInquiryButtonVisible?: boolean;
  slideHeight?: number;
}) => {
  const chunkedProducts = chunkArrayForQuadSwiper<IOpenMarketProduct>(openMarketProducts) || [];

  return (
    <DetailQuadSwiper
      title={title}
      slideHeight={slideHeight}
      slideItems={chunkedProducts.map((products, index) => (
        <QuadItemGroup key={products.map((product) => product.id).join('-')}>
          <QuadRow>
            <QuadItem>
              <OpenMarketProductPreviewCard
                product={products[0]}
                pageType={pageType}
                onClick={() => {
                  if (pageType === 'ndp') {
                    ampli.pvmClickNdpUserSellTractors({
                      id: products[0].id,
                      index: index.toString(),
                      price: products[0].hopeSellingPrice,
                      title: getOpenMarketProductTitle({
                        brandName: products[0].machine.brand.name,
                        machine: products[0].machine,
                      }),
                    });
                  }
                }}
                isInquiryButtonVisible={isInquiryButtonVisible}
              />
            </QuadItem>
            <QuadItem>
              <OpenMarketProductPreviewCard
                product={products[1]}
                pageType={pageType}
                onClick={() => {
                  if (pageType === 'ndp') {
                    ampli.pvmClickNdpPluvaTractors({
                      id: products[1].id,
                      index: index.toString(),
                      price: products[1].hopeSellingPrice,
                    });
                  }
                }}
                isInquiryButtonVisible={isInquiryButtonVisible}
              />
            </QuadItem>
          </QuadRow>
          <QuadRow>
            <QuadItem>
              <OpenMarketProductPreviewCard
                product={products[2]}
                pageType={pageType}
                onClick={() => {
                  if (pageType === 'ndp') {
                    ampli.pvmClickNdpPluvaTractors({
                      id: products[2].id,
                      index: index.toString(),
                      price: products[2].hopeSellingPrice,
                    });
                  }
                }}
                isInquiryButtonVisible={isInquiryButtonVisible}
              />
            </QuadItem>
            <QuadItem>
              <OpenMarketProductPreviewCard
                product={products[3]}
                pageType={pageType}
                onClick={() => {
                  if (pageType === 'ndp') {
                    ampli.pvmClickNdpPluvaTractors({
                      id: products[3].id,
                      index: index.toString(),
                      price: products[3].hopeSellingPrice,
                    });
                  }
                }}
                isInquiryButtonVisible={isInquiryButtonVisible}
              />
            </QuadItem>
          </QuadRow>
        </QuadItemGroup>
      ))}
      goToButton={goToButton}
    />
  );
};

const QuadItemGroup = styled.div`
  max-width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;

const QuadRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
`;

const QuadItem = styled.div`
  width: 142px;
`;
